export default "__VITE_ASSET__45a4c246__"